<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M461.7 481.4c0 13.1-8.7 23.6-19.5 23.7l-372.4.4c-10.8 0-19.5-10.6-19.5-23.6l-.4-451.8c0-13.1 8.7-23.6 19.5-23.7l274-.3 118 110.7.3 364.6z" fill="#0063f2" />
      <path fill="none" d="M50 6h412v500H50z" />
      <path d="m461.7 119.7-99.4.1c-10.8 0-19.5-10.6-19.5-23.6L342.7 9l119 110.7z" fill="#64bcf9" />
      <path d="m331.9 239 35.9-14.4c4.3-1.7 9.2-1.4 13.2.9 3.9 2.3 6.3 6.2 6.3 10.5v124c0 4.2-2.4 8.2-6.3 10.5-3.9 2.3-8.9 2.7-13.2.9L331.9 357v16c0 13.8-12.4 25-27.7 25H152c-7.3 0-14.4-2.6-19.6-7.3-5.2-4.7-8.1-11-8.1-17.7V223c0-13.8 12.4-25 27.7-25h152.3c15.3 0 27.7 11.2 27.7 25v16zm-138.4 20.7v76.6c0 2.3 1.4 4.4 3.7 5.5 2.2 1.1 5 1 7.1-.3l63.7-38.3c1.9-1.2 3.1-3.1 3.1-5.2s-1.2-4-3.1-5.2l-63.7-38.3c-2.1-1.3-4.8-1.4-7.1-.3-2.3 1.1-3.7 3.2-3.7 5.5zm0 0" fill="#fff" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
